'use client';

import { useQuery } from '@apollo/client/react';
import { useAdmin } from '@paeffgen/react/crm-documents/feature-auth';
import {
  MATERIAL_REQUESTS_QUERY,
  MaterialRequestStatus,
  type MaterialRequest,
  type MaterialRequestConnection,
} from '@paeffgen/react/crm-documents/data-access-graphql';

const HISTORY_QUERY_VARIABLES = {
  status: MaterialRequestStatus.SUBMITTED,
  first: 10,
};

/**
 * Liefert die letzten 10 versendeten (SUBMITTED) Anfragen des aktuellen
 * Kunden-/Debitor-Kontexts. Spiegelt die Query-Nutzung aus use-draft-request,
 * nur mit anderem Status-Filter und Limit.
 */
export function useRequestHistory() {
  const { adminQueryVars } = useAdmin();

  const { data, loading, refetch } = useQuery<{
    materialRequests: MaterialRequestConnection;
  }>(MATERIAL_REQUESTS_QUERY, {
    variables: { ...HISTORY_QUERY_VARIABLES, ...adminQueryVars },
    fetchPolicy: 'cache-and-network',
  });

  const requests: MaterialRequest[] =
    data?.materialRequests?.edges?.map((edge) => edge.node) ?? [];

  return { requests, loading, refetch };
}
